"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Object containing data derived from windowItems to be used in the windows overview
 *
 * @author JMt
 */


var WindowDerivedData =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowDerivedData, _DomainObject_1$Domai);

  /**
   * Creates new object of derived data for window.
   *
   * @param leadingProductPrice
   * @param leadingProductDiscount
   * @param varyingPrice
   * @param varyingDiscount
   */
  function WindowDerivedData(leadingProductPrice, leadingProductDiscount, varyingPrice, varyingDiscount) {
    var _this;

    _classCallCheck(this, WindowDerivedData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowDerivedData).call(this));
    _this.leadingProductPrice = leadingProductPrice;
    _this.leadingProductDiscount = leadingProductDiscount;
    _this.varyingPrice = varyingPrice;
    _this.varyingDiscount = varyingDiscount;
    return _this;
  }

  _createClass(WindowDerivedData, null, [{
    key: "empty",
    value: function empty() {
      return new WindowDerivedData(null, null, null, null);
    }
  }]);

  return WindowDerivedData;
}(DomainObject_1.DomainObject);

exports.WindowDerivedData = WindowDerivedData;
WindowDerivedData.EMPTY = new WindowDerivedData(null, null, false, false);

WindowDerivedData.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowDerivedData.name);
  return {
    leadingProductPrice: builder.opt(builder.bigNum('leadingProductPrice')),
    leadingProductDiscount: builder.opt(builder.bigNum('leadingProductDiscount')),
    varyingPrice: builder.opt(builder.bool('varyingPrice')),
    varyingDiscount: builder.opt(builder.bool('varyingDiscount'))
  };
}();